// import { configureStore } from '@reduxjs/toolkit'

export const initialState = {
    customerData: localStorage.getItem('userData'),
    userPaymentInfo: localStorage.getItem('userPaymentInfo'),
};
const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_CUSTOMER_DATA":
            return { ...state, customerData: action.payload };
        case "SET_USER_PAYMENT_INFO":
            if (action.payload === null) {
                localStorage.removeItem('userPaymentInfo');
            }
            else {
                localStorage.setItem('userPaymentInfo', JSON.stringify(action.payload));
            }
            return { ...state, userPaymentInfo: action.payload };
        default:
            return state;
    }
};

export default rootReducer;